// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__1Ykv5","detailsBorder":"styles_detailsBorder__3lEK7"};